/** KFC（履行中心）对应的 system_access 权限码 */
export const KFC_SYSTEM_ACCESS = 'koc_fulfilling';

export interface AccessTraits {
  role?: string;
  system_access?: string[] | string;
  [key: string]: unknown;
}

/** 将 system_access（数组或 JSON 字符串）规范为 string[] */
export function normalizeSystemAccess(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((v): v is string => typeof v === 'string');
  }
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.filter((v): v is string => typeof v === 'string');
      }
    } catch {
      // ignore
    }
    return value ? [value] : [];
  }
  return [];
}

/**
 * 是否具备指定子系统访问权限。
 * super_admin 旁路，与 auth 控制台 usePermissions 一致。
 */
export function hasSystemAccess(
  traits: AccessTraits | null | undefined,
  required: string
): boolean {
  if (!traits) return false;
  if (traits.role === 'super_admin') return true;
  return normalizeSystemAccess(traits.system_access).includes(required);
}

/** 是否可访问 KFC（履行中心） */
export function hasKfcAccess(traits: AccessTraits | null | undefined): boolean {
  return hasSystemAccess(traits, KFC_SYSTEM_ACCESS);
}

/** 是否可查看 KFC 操作日志（仅 admin / super_admin） */
export function canViewOperationLogs(traits: AccessTraits | null | undefined): boolean {
  if (!traits?.role) return false;
  return traits.role === 'admin' || traits.role === 'super_admin';
}
